import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spin, Typography } from 'antd';
import { renderAsync } from 'docx-preview';

const { Text } = Typography;

export default function ProductKnowledgeDocxPreview(props) {
    const { document, loading, error } = props;
    const containerRef = useRef(null);
    const [renderError, setRenderError] = useState('');
    const [rendering, setRendering] = useState(false);

    useEffect(() => {
        let isActive = true;

        const renderDocument = async () => {
            if (loading || !document || !containerRef.current) return;
            setRendering(true);
            setRenderError('');
            containerRef.current.innerHTML = '';

            try {
                await renderAsync(document, containerRef.current, undefined, {
                    className: 'product-knowledge-docx',
                    inWrapper: true,
                    renderHeaders: true,
                    renderFooters: true,
                    breakPages: true,
                    ignoreLastRenderedPageBreak: false
                });
            } catch (renderingError) {
                if (isActive) {
                    setRenderError(renderingError.message || 'Không thể hiển thị nội dung DOCX');
                }
            } finally {
                if (isActive) setRendering(false);
            }
        };

        renderDocument();
        return () => {
            isActive = false;
        };
    }, [document, loading]);

    if (error) {
        return <Alert type="error" showIcon message="Không thể tải tài liệu review" description={error} />;
    }

    if (loading || !document) {
        return (
            <div style={{ minHeight: 180, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
                <Text type="secondary" style={{ marginTop: 12 }}>Đang tải tài liệu DOCX để review…</Text>
            </div>
        );
    }

    return (
        <div style={{ position: 'relative' }}>
            {rendering && (
                <div style={{ position: 'absolute', zIndex: 1, top: 12, right: 12, background: '#fff', padding: '4px 8px', border: '1px solid #e5e7eb' }}>
                    <Spin size="small" /> <Text type="secondary">Đang render DOCX</Text>
                </div>
            )}
            {renderError && <Alert style={{ marginBottom: 12 }} type="error" showIcon message="Không thể render DOCX" description={renderError} />}
            <div
                ref={containerRef}
                style={{
                    minHeight: 220,
                    maxHeight: 620,
                    overflow: 'auto',
                    border: '1px solid #d9d9d9',
                    background: '#f0f2f5',
                    padding: 16
                }}
            />
        </div>
    );
}
